module.exports = __webpack_public_path__ + "img/pin_ciel.23d2364f.svg";